import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["loader", "results", "form"]

    connect() {
        // Initialize - ensure loader is hidden initially
        if (this.hasLoaderTarget) {
            this.loaderTarget.classList.add("hidden")
        }

        // Listen for turbo:frame-render or turbo:stream-render event
        document.addEventListener("turbo:frame-render", this.hideLoader.bind(this))
        document.addEventListener("turbo:stream-render", this.hideLoader.bind(this))
    }

    disconnect() {
        // Clean up event listeners when controller is disconnected
        document.removeEventListener("turbo:frame-render", this.hideLoader.bind(this))
        document.removeEventListener("turbo:stream-render", this.hideLoader.bind(this))
    }

    // This is called when the form is submitted
    showLoader(event) {
        // Show the loading spinner
        if (this.hasLoaderTarget) {
            this.loaderTarget.classList.remove("hidden")
        }

        // Clear any previous results
        if (this.hasResultsTarget) {
            this.resultsTarget.innerHTML = ""
        }
    }

    // Hide the loader when results are rendered
    hideLoader() {
        if (this.hasLoaderTarget) {
            this.loaderTarget.classList.add("hidden")
        }
    }
}
